import cx from 'classnames';
import { useDrag } from 'react-dnd';
import { isMobile, isTablet } from 'react-device-detect';
import { isResponseOk } from '../../../../../../utility/isResponseOk';
import { moveMasterScheduleAssignmentToAnotherCellService } from '../../../../../../services/scheduling';
import dayjs from 'dayjs';

const BothHalvesCell = ({
  cell,
  formData,
  scheduleData,
  selectedUser,
  getScheduleData,
  selectedCells,
  sidebarAction,
  selectedAssignmentsToDelete,
  showNames,
}) => {
  const [collected, drag] = useDrag(
    () => ({
      type: 'master_schedule_both_halves_assignment',
      item: { assignment: { ...cell.both_halves_user } },
      canDrag: !isMobile && !isTablet,
      end: async (item, monitor) => {
        try {
          const dropResult = monitor.getDropResult();

          const assignments = [];

          scheduleData.units.forEach((unit) => {
            unit.roles.forEach((role) => {
              role.master_scheduling_cells.forEach((cellItem) => {
                if (cellItem.first_half_user && cellItem.first_half_user?.user_id === item.assignment.user_id) {
                  assignments.push({ id: cellItem.first_half_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'first_half' });
                }
                if (cellItem.second_half_user && cellItem.second_half_user?.user_id === item.assignment?.user_id) {
                  assignments.push({ id: cellItem.second_half_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'second_half' });
                }
                if (cellItem.both_halves_user && cellItem.both_halves_user?.user_id === item.assignment?.user_id) {
                  assignments.push({ id: cellItem.both_halves_user.id, day: cellItem.day, shift: cellItem.shift, halfPart: 'both_halves' });
                }
              });
            });
          });

          if (
            assignments.find((assignmentItem) => {
              return (
                assignmentItem.day === dropResult.cell.day &&
                assignmentItem.shift === dropResult.cell.shift &&
                assignmentItem.id !== item.assignment.id
              );
            })
          ) {
            return;
          }

          if (dropResult?.cell) {
            const payload = {
              assignment_id: item.assignment.id,
              new_cell_id: dropResult.cell.id,
              half_part: 'both_halves',
            };
            const response = await moveMasterScheduleAssignmentToAnotherCellService(payload);
            if (isResponseOk(response)) {
              getScheduleData();
            }
          }
        } catch (e) {
          console.log(e);
        }
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [cell.both_halves_user],
  );

  const isSelecting = !!selectedCells.find((item) => item.id === cell.id);

  return (
    <div
      ref={drag}
      className={cx('full-recurring-shift', {
        'is-selected': selectedUser && selectedUser?.id === cell.both_halves_user?.user_id,
        'is-selecting': isSelecting,
        'is-deleting':
          (sidebarAction === 'delete' && selectedAssignmentsToDelete.find((item) => item === cell.both_halves_user?.id)) ||
          (selectedUser?.id === cell.both_halves_user?.user_id &&
            sidebarAction === 'delete' &&
            (formData.deleteOption?.value === 'all_repeated_and_single_shifts' || formData.deleteOption?.value === 'all_repeated_shifts')),
      })}
      style={
        cell.both_halves_user
          ? { color: cell.both_halves_user.font_color, backgroundColor: cell.both_halves_user.cell_color }
          : isSelecting && formData.halfPart?.value === 'both_halves'
            ? { color: formData.fontColor, backgroundColor: formData.cellColor }
            : undefined
      }
    >
      {cell.both_halves_user && dayjs(cell.both_halves_user.start_date).isAfter(dayjs(), 'day') && (
        <svg
          style={{ position: 'absolute', top: '2px', right: '2px' }}
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 0.5H1.5V2.25L3.1875 4L1.5 5.75V7.5H6.5V5.75L4.8125 4L6.5 2.25V0.5ZM4.25 3.5V5.25L5.67188 6.75H2.3125L3.75 5.25V3.5L2.5 2.25H5.5L4.25 3.5Z"
            fill="#101828"
          />
        </svg>
      )}
      {cell.both_halves_user
        ? showNames
          ? cell.both_halves_user.full_name
          : 'X'
        : // Only preview the selected user's name in a cell actually being added; every other empty
          // cell must stay blank, or it reads as occupied and invites a click that isn't theirs.
          isSelecting && showNames
          ? selectedUser?.full_name
          : ''}
    </div>
  );
};

export default BothHalvesCell;
